import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { formatViewObjectsPhrase } from '../../lib/utils';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import { BuyApartmentFlowPaths } from '../../routes';
import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button from 'components/button';
import Header from '../../components/header';
import caretLeft from 'assets/images/caret-left.svg';
import reit from '../../assets/images/itreit_logo.jpg';
import styles from './styles.module.scss';

export type ScreenBuySecondaryProps = {
  controls?: React.ReactNode;
};

const ScreenBuySecondary: React.FC<ScreenBuySecondaryProps> = (props) => {
  const { controls } = props;
  const navigate = useNavigate();
  const { isLoading, count } = useLimitsSecondary(true, 'Secondary');

  const handleBack = () => navigate(-1);

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div>
          <Menu />
          <IconButton icon={caretLeft} onClick={handleBack} />
        </div>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Подбор объектов</h1>
          <div className={styles.description}>Вторичное жилье</div>
        </div>
        <div>{controls}</div>
      </header>

      <section
        style={{
          marginBottom: 0,
        }}
        className={clsx(styles.content, styles.contentWithPadding)}
      >
        <div className={styles.containerButton}>
          {/* <img className={styles.house} src={house} width={187} alt='Дом с ключём' /> */}
          <img
            className={styles.reit}
            src={reit}
            width={350}
            alt='Логотип reit'
            style={{ marginTop: 180 }}
          />
          <Header className={styles.text} text='Сервис умных сделок с недвижимостью' />
        </div>
      </section>

      <footer className={styles.buttons}>
        <Button
          label={isLoading ? 'Загрузка' : formatViewObjectsPhrase(count)}
          loading={isLoading}
          onClick={() => navigate(BuyApartmentFlowPaths.apartmentListBuySecondary)}
          disabled={isLoading || count === undefined}
          variant={'gray'}
          className={clsx(
            styles.viewApartmentsButton,
            !isLoading && styles.viewApartmentButtonShow,
          )}
        />
        <Button
          label={'Подобрать квартиру вторички'}
          onClick={() => navigate(`${BuyApartmentFlowPaths.buySecondaryStreetMap}/#address`)}
          variant={'secondary'}
        />
      </footer>
    </main>
  );
};

export default ScreenBuySecondary;
